<!--  -->
<template>
  <div class="zyjs"> 
    <div class="header">
      <my-header></my-header>
    </div>
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="swiper">
      <my-swiper></my-swiper>
    </div>

    <div class="zyjscontent">
      {{ title }}
    </div>

    <div class="article" style="height: 50px;">
      <my-article newsTitle="友情链接" newsType="" style="height: 430px;color:rgb(80, 150, 255);font-weight: bold;width: 56%;">
      </my-article>
    </div>
    <div class="link" style="height: 150px;">
      <my-link></my-link>
    </div>
    <div class="footer" style="height: 100px;">
      <my-footer></my-footer>
    </div>
  </div>
</template>

<script>
import header from "../components/header/header.vue"
import navbar from "../components/navbar/navbar.vue"
import swiper from "../components/swiper/swiper.vue"
import article from "../components/article/article.vue"
import footer from "../components/footer/footer.vue"
import link from "../components/link/link.vue"
export default {
  components:{
    "my-header":header,
    "my-navbar":navbar,
    "my-swiper":swiper,
    "my-article":article,
    'my-footer':footer,
    "my-link":link,
  },
  data () {
    return {
      title:"专业建设跳转了"
    }
  }
}
</script>

<style  scoped>
.zyjscontent{
  font-size: 25px;
  color: blueviolet;
  
}
.article{
  display: flex;
  justify-content: center;
}
.link{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/zyjs.vue